import React from 'react';
import { FadeIn, ExitingPersistence, isReducedMotion } from '@atlaskit/motion';
import { useTransitionView } from '../../../controllers/use-transition-view/index.tsx';
import type { FullscreenTransitionProps } from './types.tsx';

export const FullscreenTransition = ({
	children,
	renderCondition,
}: FullscreenTransitionProps): React.JSX.Element | null => {
	const { onFinishAnimation, shouldRenderView } = useTransitionView('fullscreen', renderCondition);
	if (isReducedMotion()) {
		if (renderCondition) {
			return <>{children({ transitionProps: {} })}</>;
		}
		return null;
	}
	return (
		<ExitingPersistence>
			{shouldRenderView && (
				<FadeIn
					entranceDirection="bottom"
					exitDirection="bottom"
					duration="medium"
					onFinish={onFinishAnimation}
				>
					{(fadeInProps) => children({ transitionProps: { ...fadeInProps } })}
				</FadeIn>
			)}
		</ExitingPersistence>
	);
};
